<template>
  <LayoutAuto>
    <div class="header">
      <p class="name">{{formInfo.approvalName}}</p>
    </div>
    <Sponsor ref="sponsor" :approvalInfo="formInfo" />
  </LayoutAuto>
</template>

<script>
import { loadingConfig } from '@/utils/commonConfig';
import { mapMutations } from 'vuex';
import Sponsor from '../../components/Sponsor'

// 发起页面，自定义模版查看页
export default {
  components: {
    Sponsor
  },
  data() {
    return {
      formInfo: {}
    }
  },
  created() {
    this.initData();
  },
  mounted() {
    this.setIsFullScreen(true)
  },
  methods: {
    ...mapMutations('base', {
      setIsFullScreen: 'setIsFullScreen'
    }),
    initData() {
      const { type = '' }= this.$route.query
      if (type === 'templateDetail') this.getTemplateDetail();
      if (type === 'relateForm') this.getRelateFormDetail();
    },
    getTemplateDetail() {
      const loading = this.$loading(loadingConfig)
      _api.sponsor.getTemplateDetail({ 
        id: this.$route.query.templateId 
      }).then(data => {
        this.formInfo = data
      }).finally(() => {
        loading.close()
      })
    },
    getRelateFormDetail() {
      const loading = this.$loading(loadingConfig);
      _api.sponsor.getRelateFormDetail({
        approvalSourceId: this.$route.query.approvalSourceId,
        approvalTargetId: this.$route.query.approvalTargetId,      
      }).then(data => {
        this.formInfo = data
      }).finally(() => {
        loading.close()
      })
    }
  },
}
</script>

<style lang="scss" scoped>
.header{
  .name{
    font-size: 16px;
    color: #303133;
    font-weight: 600;
    padding: 30px 0 26px 0;
  }
}
</style>